import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { TokenModule } from '@wuitk/angular/components/token';
import { FormsModule } from '@angular/forms';
import { MultiselectModule } from '@wuitk/angular/components/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { LoaderComponent } from './components/loader/loader.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    imports: [TokenModule, FormsModule, MultiselectModule, OverlayPanelModule, MatProgressSpinnerModule],
    exports: [CommonModule, LoaderComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [LoaderComponent],
    providers: [CurrencyPipe, DecimalPipe]
})
export class SharedModule {}
